import {
  BannerMessage,
  HelpAndSupportPageTiles,
  PopularTopicsTile,
} from '@varo/graphql-schema-types';
import FetchHelpAndSupportPageTile from 'services/graphql/queries/FetchHelpAndSupportPageTile';
import { ListItemProps } from 'shared/components/vxl/ListItem/ListItem';
import { showZendeskArticle } from 'shared/utils/zendesk/zendeskUtils';
import { useQuery } from 'urql';

const HelpAndSupportId = {
  POPULAR_TOPICS: 'POPULAR_TOPICS',
  BANNER_ALERT_MESSAGE: 'BANNER_ALERT_MESSAGE',
  MY_VARO_CONTACT_US: 'MY_VARO_CONTACT_US',
};

const useHelpAndSupport = () => {
  const [{ data, error, fetching }] = useQuery<{
    helpAndSupportPageTiles: HelpAndSupportPageTiles;
  }>({
    query: FetchHelpAndSupportPageTile,
    requestPolicy: 'network-only',
  });

  const tiles = data?.helpAndSupportPageTiles?.tiles || [];

  const popularGroupData = tiles.find(
    (tile): tile is PopularTopicsTile =>
      tile.id === HelpAndSupportId.POPULAR_TOPICS,
  );

  const popularTopicsListData = popularGroupData?.popularTopics || [];

  const formattedPopularTopicsListData: ListItemProps[] =
    popularTopicsListData.map((item) => {
      return {
        id: item?.id,
        primaryCopy: item?.title,
        onPress: () => {
          if (item?.articleId) {
            showZendeskArticle(Number(item.articleId));
          }
        },
        analyticsId: item?.onClickAnalytics?.name,
        customAttributes: {
          faq_name: item?.onClickAnalytics?.properties?.[2]?.value,
        },
      };
    });

  const bannerData = tiles.filter(
    (
      tile,
    ): tile is HelpAndSupportPageTiles & {
      banners?: { message: BannerMessage }[];
    } => tile.id === HelpAndSupportId.BANNER_ALERT_MESSAGE,
  );
  const warningMessage =
    typeof bannerData?.[0]?.banners?.[0]?.message === 'string'
      ? bannerData[0].banners[0].message
      : '';

  const subTitleUrl = popularGroupData?.subTitleUrl;

  const subTitle = popularGroupData?.subTitle;

  return {
    formattedPopularTopicsListData,
    warningMessage,
    error,
    loadingHelpAndSupportData: fetching,
    subTitleUrl,
    subTitle,
  };
};

export default useHelpAndSupport;
